module.exports = "/assets/data/6f0b465f4f27fefd86d80423d4eaefa7-BT12.data.json";